/**
 * The following Javascript Module provides scripting for the necessary
 * UX elements of the warranty landing page
 */

require('../components/spinner');

/**
 * Update Display
 * - Show / Hide the form based on the link clicked
 * - Update the selected element
 * - Update the form title
 * - Show the corresponding warranty information.
 * - Populate the category form field
 *
 * @param {Object} element Product Category Link Clicked
 */
function updateDisplay(element) {
    $.spinner().start();
    let landingPageElement = $('.warranty-landing-page');
    let purchasedAfterElement = $('.warranty-request-purchasedAfter');

    /**
     * Update the title
     */
    landingPageElement.find('.js__selected_category').text(element.text());

    /**
     * Update the selected element
     */
    element.siblings().removeClass('active');
    element.addClass('active');

    /**
     * Show / Hide the form based on the data- attribute on the link
     */
    let showForm = element.attr('data-show-form') === 'true';

    if (showForm) {
        landingPageElement.find('.form-container').show();
    } else {
        landingPageElement.find('.form-container').hide();
    }

    /**
     * Show / Hide the form based on the data- attribute on the link
     */
    let showPurchasedAfterCheckbox = element.attr('data-show-purchase-after-checkbox') === 'true';
    let purchasedAfterCheckbox = purchasedAfterElement.find('#warranty-request-purchasedAfter');

    if (showPurchasedAfterCheckbox) {
        purchasedAfterElement.show();
        if (purchasedAfterCheckbox.is(':checked')) {
            purchasedAfterCheckbox.click();
        }
    } else {
        purchasedAfterElement.hide();
        if (!purchasedAfterCheckbox.is(':checked')) {
            purchasedAfterCheckbox.click();
        }
    }

    /**
     * Show the correct warranty information
     */
    let categoryID = element.attr('data-target').replace('#tabbedContainer_warranty__', '');

    landingPageElement.find('.warranty-information').hide();
    landingPageElement.find(`#tabbedContainer_warranty__${categoryID}`).show();

    /**
     * Show the correct left rail information
     */
    landingPageElement.find('.warranty-left-rail-category ').hide();
    landingPageElement.find(`#left-rail-${categoryID}`).show();

    /**
     * Update the Selected Product Category Form Element
     */
    let categoryElement = landingPageElement.find('#warranty-request-category');

    if (categoryElement.length > 0) {
        categoryElement.val(categoryID);
    }

    $('.tabbed-container').removeClass('invisible');

    setTimeout(function () {
        $.spinner().stop();
    }, 500);
}

/**
 * The following Javascript Module provides scripting for the necessary
 * UX elements of the warranty landing page
 */

/**
 * Hide the Form fields
 */
function hideTheForm() {
    var toggableFormFields = $('.toggable-form-fields');

    toggableFormFields.addClass('d-none');
}

/**
 * Show the Form fields
 */
function showTheForm() {
    var toggableFormFields = $('.toggable-form-fields');

    toggableFormFields.removeClass('d-none');
}

/**
 * Update the Form
 * Hide the form if the purchase after checkbox is not checked, enable otherwise
 */
function updateTheForm() {
    var purchasedAfterCheckbox = $('#warranty-request-purchasedAfter');

    if (purchasedAfterCheckbox.length > 0) {
        if (purchasedAfterCheckbox.is(':checked')) {
            showTheForm();
        } else {
            hideTheForm();
        }
    }
}

module.exports = {
    /**
     * Select the first tab in the list and
     * update the display. Add an event listener for the other product
     * category links.
     */

    init: function () {
        let landingPageElement = $('.warranty-landing-page');
        let firstTab = landingPageElement.find('.product-category-tabs a').first();

        landingPageElement.find('.warranty-information').hide();
        updateDisplay(firstTab);

        landingPageElement.find('.product-category-tabs a').on('click', function (event) {
            event.preventDefault();

            updateDisplay($(this));
        });
        updateTheForm();
        $('#warranty-request-purchasedAfter').on('change', updateTheForm);
    }
};
